import { Flex, Select } from "@mantine/core";
import { useEffect, useState } from "react";

import { getSiteList } from "pages/Admin/Site/apis/adminSiteApis";
import { getObj } from "pages/Admin/SiteEdit/apis/adminSiteEditApis";
import { getCombo } from "pages/Admin/User/apis/adminUserApis";
import SiteEditAddForm from "./SiteEditAddForm";

function SiteEditDataTable() {
  const [groupList, setGroupList] = useState([]);
  const [selectGroup, setSelectGroup] = useState();

  const [fieldList, setFieldList] = useState([]);
  const [selectField, setSelectField] = useState();

  const [defaultObjectList, setDefaultObjectList] = useState([]);
  const [defaultImgyeList, setDefaultImgyeList] = useState([]);
  const [defaultObjectState, setDefaultObjectState] = useState();

  useEffect(() => {
    getCombo().then((res) => {
      const groupList = res
        .filter((item) => item.id === "group")
        .map((group) => ({ label: group.name, value: group.code }));
      setGroupList(groupList);
    });
  }, []);

  useEffect(() => {
    getSiteList(100, 1, selectGroup ?? null).then((res) => {
      const filteredList = res
        .filter((item) => item.group_id === selectGroup)
        .map((field) => ({
          label: field.field_nm,
          value: field.field_id,
          object_id: field.object_id ?? "",
          user_id: field.field_manager_id,
          group_id: field.group_id,
        }));
      setFieldList(filteredList);
    });
  }, [selectGroup]);

  useEffect(() => {
    setDefaultObjectState(fieldList.find((field) => field.value === selectField));
  }, [fieldList, selectField]);

  useEffect(() => {
    getObj(defaultObjectState?.value, defaultObjectState?.object_id).then((res) => {
      setDefaultObjectList(
        res.view.sort((a, b) => {
          if (a.obj_seq !== b.obj_seq) {
            return a.obj_seq - b.obj_seq; // obj_seq 오름차순 정렬
          } else {
            return a.obj_id - b.obj_id; // obj_id 오름차순 정렬 (obj_seq가 같을 경우)
          }
        })
      );
      setDefaultImgyeList(res.imgye);
    });
  }, [defaultObjectState]);

  const SearchBar = () => {
    return (
      <Flex justify={"space-between"}>
        <Flex gap={15} mb={10} align="center">
          <Select
            placeholder="그룹선택"
            data={groupList}
            value={selectGroup}
            onChange={setSelectGroup}
          />
          <Select
            placeholder="현장선택"
            data={fieldList}
            value={selectField}
            onChange={setSelectField}
          />
        </Flex>
      </Flex>
    );
  };
  return (
    <>
      <SearchBar />
      {defaultObjectList && (
        <SiteEditAddForm
          defaultObjectState={defaultObjectState}
          defaultImgyeList={defaultImgyeList}
          defaultObjectList={defaultObjectList}
          fieldList={fieldList}
        />
      )}
    </>
  );
}

export default SiteEditDataTable;
